<template>
  <div class="form">
    <div class="container">
      <div class="form-container text-left">
        <button @click="$router.go(-1)" class="app-btn px-3 mb-4">
          <v-icon class="mr-3 white-icon" name="arrow-left" scale="1"/> Atrás
        </button>
        <div class="d-flex justify-content-between">
          <span>
            <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
            Fecha de solicitud: {{requestDetail.createdDate | formatDate}}
          </span>
          <div class="d-flex">
            <div class="application-number mr-2">
              Solicitud - <span v-if="requestDetail.conectionType == 'Simple'">UPB</span> <span v-if="requestDetail.conectionType == 'Compleja'">UPM</span>
            </div>
            <div class="application-number">
              #{{requestDetail.id}}
            </div>
        </div>
        </div>
        <h2>Diseños Aprobados</h2>
        <div class="input-wrap">
          <textarea v-model="approedDesignsData.comments" name="" id="" cols="10" rows="5"></textarea>
          <div class="mb-3">
            <label class="file">Documento Anexo<v-icon class="ml-3" name="upload" scale="1.5"/>
                <input @change="onFileChangeDocument($event)" type="file">
                <div class="file-selected" v-if="approedDesignsData.document">
                {{approedDesignsData.documentFile.name}}  - 
                    <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                </div>
            </label> 
            </div>
          <div>
            <button @click="confirmed = true; validarInput()" class="app-btn app-btn--green w-100">
              Aprobar diseños
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <div v-if="confirmed == false" class="error-modal">
      <div @click="confirmAccept = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Realmente desea aprobar los diseños?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAccept = true; confirmed = true; sendRequest()" class="app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAccept = false; confirmed = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedDoc == false" class="error-modal">
      <div @click="confirmAcceptDoc = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDoc = true; confirmedDoc = true; borrarDocumento()" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDoc = false; confirmedDoc = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import axios from "axios";

export default {
  data(){
    return {
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },  
      confirmedDoc: true,
      confirmAcceptDoc: false,    
      confirmed: true,
      approedDesignsData: {
        comments: 'Su diseño ha sido aprobado, favor reclamar los planos en el piso 8 del edificio Boulevard del Rio. Traer dos copias adicionales',
        document: null,
        confirmAccept: false,
        confirmed: true,
        documentFile: null
      },
      loading: false,
      error: '',
      confirmRefuse: false,
      confirmed: true
    }
  },
  methods: {
    borrarDocumento(){
      this.approedDesignsData.document = null;     
    },
    validarInputDocument(){
      this.confirmedDoc = false;
        return;        
    },
    validarInput(){
      this.confirmed = false;
      if (this.approedDesignsData.comments == '') {
        this.error = 'Complete los datos solicitados para la aprobación.';
        this.confirmed = true;
        return;
      }     
    },
    sendRequest(){
      this.loading = true;

      let approedDesignsData = {
        "comments":this.approedDesignsData.comments,
        "idRequest": this.requestDetail.id,
        "approvingUser": this.$store.state.email,
        "updateDate":new Date(),
        "createDate":new Date()
      }

      if (this.approedDesignsData.document != null) {
        approedDesignsData.document = this.approedDesignsData.document;
        approedDesignsData.documentName = this.approedDesignsData.documentFile.name;        
      }

      
      axios.post("approvedDesign/add", approedDesignsData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        this.updateRequest();
        this.userActionLog();
        // this.loading = false;
        // this.$router.push('adminRequestDetail');
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    },
    userActionLog(){

      let userAction = {
        "idRequest":this.requestDetail.id,
        "action": "Aprobó los diseños",
        "email": localStorage.getItem('email'),
        "editedDate":new Date()
      }
      axios.post("userActionLogController/add", userAction, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(data =>{
        console.log("si agrego el log")
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'no agrego el log';
      })
    },

    onFileChangeDocument(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.approedDesignsData.document  = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.approedDesignsData.documentFile = files;
    },
    updateRequest(){

      let requestData = {
        "id":this.requestDetail.id,
        "conectionType":this.requestDetail.conectionType,
        "proyectName":this.requestDetail.proyectName,
        "observactions":this.requestDetail.observactions,
        "stage":"pendiente-solicitud-supervision",
        "status":"en proceso",
        "applicantInfo":{
          "id":this.requestDetail.applicantInfo.id
        },
        "electricInfrastructure":{
          "id":this.requestDetail.electricInfrastructure.id
        },
        "estateInfo":{
          "id":this.requestDetail.estateInfo.id
        },
        "serviceDetail":{
          "id":this.requestDetail.serviceDetail.id
        },
        "subscriptorInfo":{
          "id":this.requestDetail.subscriptorInfo.id
        },
        "typesUseEconomicActivity":{
          "id":this.requestDetail.typesUseEconomicActivity.id
        },
        "createdDate": this.requestDetail.createdDate,
        "editedDate": new Date()
      }

      axios.post("request/update", requestData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        this.setRequestDetail(result.data);
        this.loading = false;
        this.$router.push('adminRequestDetail');
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    },
    ...mapMutations({
      setRequestDetail: 'setRequestDetail'
    })
  },
  computed: {
    ...mapState({
      requestDetail: state => state.requestDetail
    })
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;
  .container {
    // background-color: #444444;
  }
  
}
</style>